'use client';

import React from 'react';
import { Link, usePathname } from '@/navigation';
import { getUserCity } from '@/shared/lib/city/getUserCity';
import { formatMoney } from '@/shared/lib/string/formatMoney';
import type { IMedcenterService } from '@/entities/medcenter/model/types';
interface Props {
  list: IMedcenterService[];
}
export const MedcenterServicesList: React.FC<Props> = ({
  list
}) => {
  const pathname = usePathname();
  const city = getUserCity(pathname);
  return <div className="flex flex-col" data-sentry-component="MedcenterServicesList" data-sentry-source-file="MedcenterServicesList.tsx">
      {list.map(service => <Link href={{
      pathname: `/${city}/services/${service.alias}`
    }} key={service.alias} target="_blank" className="grid w-full grid-cols-[auto,80px] gap-2 border-b border-b-borderPrimary py-5 last:border-b-0 last:pb-0 md:gap-4">
          <span className="text-sm text-textSecondary">{service.name}</span>
          <span className="text-end text-base font-bold">{formatMoney(service.price)} ₸</span>
        </Link>)}
    </div>;
};